import React from 'react';
import { MenuItem } from '@mui/material';
import { IoMdCheckmark } from 'react-icons/io';

interface AggregationMenuItemProps {
  isChecked: boolean;
  onClick: () => void;
  optionName: string;
  isDisabled: boolean;
  menuStyle: React.CSSProperties;
  menuSelectedStyle: React.CSSProperties;
}

const AggregationMenuItem: React.FC<AggregationMenuItemProps> = ({
  isChecked,
  onClick,
  optionName,
  isDisabled,
  menuStyle,
  menuSelectedStyle,
}) => {
  return (
    <div style={{ display: "flex" }}>
      <span
        style={{
          color: "rgb(211, 211, 211)",
          paddingLeft: "5px",
          paddingTop: "4px",
          position: "absolute",
        }}
      >
        {isChecked ? <IoMdCheckmark style={{color : "#7c7979"}}/> : null}
      </span>
      <MenuItem
        onClick={onClick}
        sx={{
          ...menuStyle,
          width: "100%",
          ...(isChecked && menuSelectedStyle),
        }}
        disabled={isDisabled}
      >
        {optionName}
      </MenuItem>
    </div>
  );
};

export default AggregationMenuItem;
